
import React, {Component} from 'react'
import { connect } from 'react-redux'
import GenericPageButton from '../GenericPageButton'
import GenericDockButton from '../GenericDockButton'

const translator = require('../../../../utils/translator/translator.js');

class TillStatusButton extends Component 
{
    render()
    {
        var caption = translator.getLabel("closeTill");
        if (this.props.tillStatus == "close")
            caption = translator.getLabel("openTill");

        if (this.props.isPageView)
            return <GenericPageButton   button={this.props.button} 
                                        onClick={this.props.onClick} 
                                        marginLeft={this.props.marginLeft}
                                        marginRight={this.props.marginRight}
                                        caption={caption}/>
        
        return <GenericDockButton   button={this.props.button} 
                                    onClick={this.props.onClick} 
                                    marginLeft={this.props.marginLeft}
                                    marginRight={this.props.marginRight}
                                    caption={caption}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                tillStatus: state.tillStatus
           }
}

export default connect(mapStateToProps)(TillStatusButton)